export default "__VITE_ASSET__5db2604b__"